import {Injectable} from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import {Observable} from 'rxjs';
import {ResourceService} from '../resource.service';
import {combinedDemandUrl, maxEnergyUrl, maxOutputUrl, predictedOutputUrl, programUrl, sitesUrl, statisticsUrl} from '../../domain/constants';
import {AuthGuardService} from '../auth-guard.service';
import {Dispatch, Program, UIDispatch} from '../../domain/cloud-topology';
import {environment} from "../../../environments/environment";
import {map} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class ProgramService {
  constructor(private http: HttpClient) {}

  getPrograms(): Observable<Program[]> {
    return this.http.get(ResourceService.buildUrl([environment.vppUrl, programUrl])).pipe(map(res => res['data']));
  }

  getProgram(programId: string): Observable<Program> {
    return this.http.get(ResourceService.buildUrl([environment.vppUrl, programUrl, programId])).pipe(map(res => res['data']));
  }

  putProgram(programId: string, payload: Program) {
    return this.http.put(ResourceService.buildUrl([environment.vppUrl, programUrl, programId]), payload).pipe(map( auditRecord => {
      return JSON.parse(auditRecord['data']['payloadAfter']) as Program;
    }));
  }

  postProgram(payload: Partial<Program>): Observable<Program> {
    return this.http.post(ResourceService.buildUrl([environment.vppUrl, programUrl]), payload).pipe(map( auditRecord => {
      return JSON.parse(auditRecord['data']['payloadAfter']) as Program;
    }));
  }

  removeProgram(program: Program) {
    return this.http.delete(ResourceService.buildUrl([environment.vppUrl, programUrl, program.id]),  {
      responseType: 'text',
    }).pipe(map(res => res['data']));
  }

  getProgramSites(program: Program): Observable<any[]> {
    return this.http.get(ResourceService.buildUrl([environment.vppUrl, programUrl, program.id, sitesUrl])).pipe(map(res => res['data']));
  }

  putProgramSites(program: Program, siteIds): Observable<Program> {
    return this.http.put(ResourceService.buildUrl([environment.vppUrl, programUrl, program.id, sitesUrl]), siteIds).pipe(map(res => res['data']));
  }

  getMaxOutput(program: Program): Observable<number> {
    return this.http.get(ResourceService.buildUrl([environment.vppUrl, programUrl, program.id, maxOutputUrl])).pipe(map(res => res['data']));
  }

  getMaxEnergy(program: Program): Observable<number> {
    return this.http.get(ResourceService.buildUrl([environment.vppUrl, programUrl, program.id, maxEnergyUrl])).pipe(map(res => res['data']));
  }

  getCombinedDemand(program: Program) {
    return this.http.get(ResourceService.buildUrl([environment.vppUrl, programUrl, program.id, statisticsUrl, combinedDemandUrl])).pipe(map(res => res['data']));
  }
}
